export const lecturesURL = '/api/lecture-api/';
export const socketURLForID = (id: string) => `wss://demo.alerty.live/lectures/${id}/sockets/`;
